<template>
  <section class="mt-3">
    <b-overlay :show="loading" rounded="sm">
      
      <div class="mt-1">
        <b>{{ $t('ONLY_FOR_SEFOS_MESSAGES') }}</b>
      </div>

      <div class="mt-1">
        {{ $t('OUT_OF_THE_OFFICE.AUTOMATIC_REPLY_INFORMATION_TEXT') }}
      </div>

      <h5 class="mt-3">{{ $t("OUT_OF_THE_OFFICE.ACTIVATE_AUTOMATIC_REPLIES") }}</h5>
      <div class="mt-1">
        <b-form-checkbox
          switch
          v-model="out_of_office_enabled"
          :aria-label="$t('NARR.OUT_OF_OFFICE.SWITCH_TO_ACTIVATE_AUTO_REPLY')"
        ></b-form-checkbox>
      </div>

      <h5 class="mt-3">{{ $t("OUT_OF_THE_OFFICE.SEND_REPLIES_UNDER_SPECIFIC_TIME") }}</h5>
      <div class="mt-1">  
        <b-form-checkbox
          switch
          v-model="out_of_office_date"
          :checked="true"
          :unchecked-value="false"
          :disabled="!out_of_office_enabled"
          :aria-label="$t('NARR.OUT_OF_OFFICE.SWITCH_TO_SPECIFY_DATE_TIME_FOR_AUTO_REPLY')"
        ></b-form-checkbox>
      </div>

      <PickDate
      v-model="startDateTime"
      :use-label="$t('FROM')"
      use-clock
      :isDisabled="!out_of_office_date"
      @valid="(n) => (validStart = n)"></PickDate>

      <PickDate
      v-model="endDateTime"
      :start-date="startDateTime"
      :use-label="$t('TO')"
      :isDisabled="!out_of_office_date"
      use-clock
      @valid="(n) => (validEnd = n)"></PickDate>


      <h5 class="mt-3" v-if="out_of_office_enabled">{{ $t("MESSAGE") }}</h5>
      <div class="mt-1" v-if="out_of_office_enabled">    
        <b-form-textarea
          v-model="out_of_office_message"
          rows="5"
          max-rows="6"
          class="w-100 d-block"
          :aria-label="$t('NARR.OUT_OF_OFFICE.INPUT_TO_ENTER_AUTO_REPLY_MESSAGE')"
        ></b-form-textarea>
      </div>
      <hr class="p-0 m-0 mt-4 mb-2" />
            

      <b-button variant="primary" class="btn-fill" @click="saveSubmit" :disabled="!isFormValid">{{ $t('SAVE') }}</b-button>
    </b-overlay>
  </section>
</template>

<script>
import { DateTime } from "luxon";
import PickDate from "../Input/PickDate";
export default {
  props: ['information'],
  components: {
    PickDate
  },
  data() {
    return {
      validEnd: true,
      validStart: true,
      loading: false,
      out_of_office_enabled: this.information.functionbox.out_of_office_enabled,
      out_of_office_message: this.information.functionbox.out_of_office_message,
      startDateTime: this.information.functionbox.out_of_office_start_date,
      endDateTime: this.information.functionbox.out_of_office_end_date,
      out_of_office_date: this.information.functionbox.out_of_office_date,
      isFormValid: true,
    };
  },
  methods: {
    async saveSubmit() {      
      this.loading = true;
      try {
       await this.$http
        .post(`${this.user.hostname}/administration/functionbox/out-of-office`, {
          account_id: 0,
          functionbox_uuid: this.information.functionbox.functionbox_uuid,
          out_of_office_enabled: this.out_of_office_enabled,
          out_of_office_message: this.out_of_office_message,
          out_of_office_start_date: this.startDateTime,
          out_of_office_end_date: this.endDateTime,
          out_of_office_date: this.out_of_office_date
        });
        this.$noty.info(this.$t('SAVED'));
        await this.$store.dispatch("user/fetchUser");
        this.loading = false;
      } catch {
        this.loading = false;
      }
    },
  },
  mounted() {
    let now = new DateTime.local().toUTC();
    this.startDateTime = this.information.out_of_office_start_date == "0001-01-01T00:00:00" ? now :  this.information.out_of_office_start_date;
    this.endDateTime = this.information.out_of_office_end_date == "0001-01-01T00:00:00" ? now.plus({ minutes: 60 }) : this.information.out_of_office_end_date;
  }
};
</script>
